import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { serverurl } from "../../environments/environment";
import { SnackService } from './snack.service';


@Injectable({
  providedIn: 'root'
})
export class AccountsService {
  http = inject(HttpClient);
  snack = inject(SnackService);

  constructor() { }


  async searchUsers(query: string) {
    return await new Promise((resolve) => {
      this.http.
        get(`${serverurl}/user/search/${query}`)
          .subscribe({
            next: async (data: any) => {
              resolve(data);
            },
            error: (err) => {
              this.snack.error(err);
              resolve(false);
            },
          }
        );
    });
  }
} //! TODO: use and test searchUsers
